import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { IActionResult } from '../../microsoft/asp-net-core/mvc/models';

@Injectable({
  providedIn: 'root',
})
export class WoodCertificationPlanningOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  updateCertifications = (woodCertificationId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IActionResult>({
      method: 'PUT',
      url: `/api/orchestrator/wood-certifications/${woodCertificationId}/update-certifications`,
    },
    { apiName: this.apiName,...config });
}